/* eslint-disable max-len */

import { ClaimTypeText } from '@constants';
import { SplitLine } from '../common';
import { Merchandise } from '../merchandise';
import { Panel } from '../panel';
import classes from './index.module.css';
import { RemarkPanel } from '../choose/remark-panel';

const PackageItem = ({
  orderName, packageItem, index, reasonList, orderNameTitleText = 'Order',
}) => {
  if (!packageItem) {
    return null;
  }
  const { items, attachments } = packageItem || {};

  return (
    <section>
      {index !== 0 ? <SplitLine /> : null}
      <section className={classes.package_item}>
        <span className={classes.order_name_title}>{orderNameTitleText}</span>
        {orderName}
      </section>
      {items?.map((item, itemIndex) => {
        const files = attachments || item.attachments;
        const comment = packageItem.comment || item.comment;
        const reason = packageItem.reason || item.reason;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <section key={`${item.lineItemId}_${itemIndex}`}>
            {itemIndex === 0 ? null : <SplitLine />}
            <Merchandise item={item} className={classes.ra_merchandise} />
            {(reason || !!files?.length)
              && (
                <RemarkPanel
                  title={reasonList ? reasonList?.find((v) => v.value === reason)?.label : reason}
                  files={files?.map((item) => item.originalFileName)}
                  additional={(comment)}
                />
              )}
          </section>
        );
      })}
    </section>
  );
};

const FileList = ({ files }) => (
  <>
    <SplitLine />
    <section className={classes.reported_title_padding}>
      <span className={classes.title_bold}>Supporting documents:</span>
      <span className={classes.files_name}>{files.map((file) => file.name || file.originalFileName).join('; ')}</span>
    </section>
  </>
);

export const ReviewItemList = ({
  selectedPackageList, type,
  files, comments,
  reasonList, issueTypeDesc, orderNameTitleText,
}) => (
  <Panel className={classes.panel}>
    <section>
      <span className={classes.title_bold}>Issue reported:</span>
      <span>
        {issueTypeDesc || ClaimTypeText[type]}
      </span>
    </section>
    {selectedPackageList?.map((packageItem, index) => (
      <PackageItem
        // eslint-disable-next-line react/no-array-index-key
        key={`${packageItem.fulfillmentName}_${index}`}
        packageItem={packageItem}
        index={index}
        orderName={packageItem.fulfillmentName}
        reasonList={reasonList}
        type={type}
        orderNameTitleText={orderNameTitleText}
      />
    ))}
    {files?.length ? <FileList files={files} /> : null}
    {comments && (
      <div className={classes.comments}>
        <span className={classes.title_bold}>Additional comments:</span>
        <span className={classes.comment_text}>{comments}</span>
      </div>
    )}
  </Panel>
);

export const DhgateReviewItemList = ({ infoList = {} }) => {
  const {
    items = [], issueTypeDesc, attachments: outerAttachments, comment: outerComment,
  } = infoList;
  const { trackingNumber } = items[0] || {};
  const { trackingCompany } = items[0] || {};
  return (
    <Panel className={classes.panel}>
      <section>
        <span className={classes.title_bold}>Issue reported:</span>
        <span>
          {issueTypeDesc}
        </span>
      </section>
      <section className={classes.tracking_number}>
        <span className={classes.title_bold}>Tracking number:</span>
        <span>
          {`${trackingNumber} ${trackingCompany ? `(${trackingCompany})` : ''}`}
        </span>
      </section>
      {items?.map((info) => {
        const {
          items: lineItem = [], attachments = [], comment, claimQuantity,
        } = info || {};
        return (
          lineItem?.map((item, index) => (
            <section key={`${item.lineItemId}}`}>
              {index === 0 ? null : <SplitLine />}
              <Merchandise item={{ ...item, claimQuantity }} className={classes.ra_merchandise} isShowQuantity />
              {(item.claimQuantity || !!attachments?.length || comment)
                && (
                  <section className={classes.remark}>
                    {item.claimQuantity && (
                      <section>
                        <span className={classes.bold}>Items damaged: </span>
                        {item.claimQuantity}
                      </section>
                    )}

                    {!!attachments.length && (
                      <section className={classes.photos}>
                        <span className={classes.bold}>Supporting documents:&nbsp;</span>
                        <span style={{ wordBreak: 'break-word' }}>{attachments.map((v) => v.originalFileName).join('; ')}</span>
                      </section>
                    )}
                    {!!comment && (
                      <section className={classes.additional}>
                        <span className={classes.bold}>Additional comments: </span>
                        {comment}
                      </section>
                    )}
                  </section>
                )}
            </section>
          ))
        );
      })}

      {outerAttachments?.length ? <FileList files={outerAttachments} /> : null}
      {outerComment && (
        <div className={classes.comments}>
          <span className={classes.title_bold}>Additional comments:</span>
          <span className={classes.comment_text}>{outerComment}</span>
        </div>
      )}
    </Panel>
  );
};
